import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { IReviewListViewModel } from 'src/app/ViewModel/PeerReviewModel';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-peer-review-comments-summary',
  templateUrl: './peer-review-comments-summary.component.html',
  styleUrls: ['./peer-review-comments-summary.component.css']
})
export class PeerReviewCommentsSummaryComponent implements OnInit {

  public reportServer!: string | null;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;
  public peerReviewList: IReviewListViewModel[] = [];
  public project_Id!: number;
  public groupId!: number;
  public memberId!: number;
  selectedTabIndex = 0;
  reviewNo!: string;
  constructor(private _peerReviewService: PeerReviewService, private _commonService: CommonService, private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.project_Id = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.getReviewList();
    this.bindReport()

  }

  getReviewList() {
    let input = {
      Project_Id: this.project_Id,
      member_Id: this.memberId,
      search_for: "ALL"
    }
    this._peerReviewService.GetReviewList(input).subscribe((res: IReviewListViewModel[]) => {
      this.peerReviewList = res.filter(x => x.ds_code == 32 || x.ds_code == 33 || x.ds_code==36 || x.ds_code==35);
    })
  }

  selectedReviewNo(event: any) {
    this.reviewNo = event.value == -2 ? null:event.value;
    this.reportServer = null;
    this.reportUrl = '';
    this.parameters = null;
    setTimeout(() => {
      this.bindReport();
    }, 50);

  }

  public bindReport() {
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";


    this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/PeerReviewCommentsSummary";
    this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/PeerReviewCommentsSummary";
    this.showParameters = "false";
    this.parameters = {
      "review_no": this.reviewNo ? this.reviewNo:null,
      "project_id": this.project_Id
    };


  }




}
